module.exports = __webpack_public_path__ + "static/media/f_big-score.eeb4fb45.png";